// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/rsk-font.eot?8okswn", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/rsk-font.ttf?8okswn", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/rsk-font.woff?8okswn", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/rsk-font.svg?8okswn", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#rsk-font" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'rsk-font';
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

.rsk {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'rsk-font' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.rsk-blocks:before {
  content: "\\e923";
}
.rsk-copy-full:before {
  content: "\\e921";
}
.rsk-copy-empty:before {
  content: "\\e922";
}
.rsk-microsoft-onedrive:before {
  content: "\\e91c";
}
.rsk-addedToText:before {
  content: "\\e91a";
}
.rsk-addToText:before {
  content: "\\e91b";
}
.rsk-resume:before {
  content: "\\e919";
}
.rsk-pause:before {
  content: "\\e917";
}
.rsk-delegate:before {
  content: "\\e918";
}
.rsk-fire:before {
  content: "\\e916";
}
.rsk-arrow:before {
  content: "\\e912";
}
.rsk-dash:before {
  content: "\\e915";
}
.rsk-new-file:before {
  content: "\\e911";
}
.rsk-new-folder:before {
  content: "\\e913";
}
.rsk-no-data:before {
  content: "\\e914";
}
.rsk-move:before {
  content: "\\e90d";
}
.rsk-open:before {
  content: "\\e90e";
}
.rsk-remove:before {
  content: "\\e90f";
}
.rsk-rename:before {
  content: "\\e910";
}
.rsk-cross:before {
  content: "\\e90c";
}
.rsk-text:before {
  content: "\\e90b";
}
.rsk-account-manager:before {
  content: "\\e901";
}
.rsk-buisness-competence-manager:before {
  content: "\\e902";
}
.rsk-compliance-case:before {
  content: "\\e903";
}
.rsk-hazard-log:before {
  content: "\\e904";
}
.rsk-hazard-risk-analysis:before {
  content: "\\e905";
}
.rsk-life-cycle-manager:before {
  content: "\\e906";
}
.rsk-markov:before {
  content: "\\e907";
}
.rsk-qid:before {
  content: "\\e908";
}
.rsk-risk-map:before {
  content: "\\e909";
}
.rsk-sil:before {
  content: "\\e90a";
}
.rsk-triangle-right:before {
  content: "\\e900";
}
.rsk-decrease-to:before {
  content: "\\e91f";
}
.rsk-increase-to:before {
  content: "\\e920";
}
.rsk-clock-thin:before {
  content: "\\e91e";
}
.rsk-book:before {
  content: "\\e91d";
}
.rsk-user:before {
  content: "\\e971";
}
.rsk-eye:before {
  content: "\\e9ce";
}
.rsk-eye-blocked:before {
  content: "\\e9d1";
}
.rsk-radio-checked:before {
  content: "\\ea54";
}
.rsk-radio-checked2:before {
  content: "\\ea55";
}
.rsk-radio-unchecked:before {
  content: "\\ea56";
}
.rsk-cart:before {
  content: "\\e93a";
}
.rsk-clock:before {
  content: "\\e94e";
}
.rsk-notification:before {
  content: "\\ea08";
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/rsk-font/rsk-font.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,6CAAsC;EACtC;;;yDAGyD;EACzD,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'rsk-font';\n  src:  url('fonts/rsk-font.eot?8okswn');\n  src:  url('fonts/rsk-font.eot?8okswn#iefix') format('embedded-opentype'),\n    url('fonts/rsk-font.ttf?8okswn') format('truetype'),\n    url('fonts/rsk-font.woff?8okswn') format('woff'),\n    url('fonts/rsk-font.svg?8okswn#rsk-font') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n.rsk {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'rsk-font' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.rsk-blocks:before {\n  content: \"\\e923\";\n}\n.rsk-copy-full:before {\n  content: \"\\e921\";\n}\n.rsk-copy-empty:before {\n  content: \"\\e922\";\n}\n.rsk-microsoft-onedrive:before {\n  content: \"\\e91c\";\n}\n.rsk-addedToText:before {\n  content: \"\\e91a\";\n}\n.rsk-addToText:before {\n  content: \"\\e91b\";\n}\n.rsk-resume:before {\n  content: \"\\e919\";\n}\n.rsk-pause:before {\n  content: \"\\e917\";\n}\n.rsk-delegate:before {\n  content: \"\\e918\";\n}\n.rsk-fire:before {\n  content: \"\\e916\";\n}\n.rsk-arrow:before {\n  content: \"\\e912\";\n}\n.rsk-dash:before {\n  content: \"\\e915\";\n}\n.rsk-new-file:before {\n  content: \"\\e911\";\n}\n.rsk-new-folder:before {\n  content: \"\\e913\";\n}\n.rsk-no-data:before {\n  content: \"\\e914\";\n}\n.rsk-move:before {\n  content: \"\\e90d\";\n}\n.rsk-open:before {\n  content: \"\\e90e\";\n}\n.rsk-remove:before {\n  content: \"\\e90f\";\n}\n.rsk-rename:before {\n  content: \"\\e910\";\n}\n.rsk-cross:before {\n  content: \"\\e90c\";\n}\n.rsk-text:before {\n  content: \"\\e90b\";\n}\n.rsk-account-manager:before {\n  content: \"\\e901\";\n}\n.rsk-buisness-competence-manager:before {\n  content: \"\\e902\";\n}\n.rsk-compliance-case:before {\n  content: \"\\e903\";\n}\n.rsk-hazard-log:before {\n  content: \"\\e904\";\n}\n.rsk-hazard-risk-analysis:before {\n  content: \"\\e905\";\n}\n.rsk-life-cycle-manager:before {\n  content: \"\\e906\";\n}\n.rsk-markov:before {\n  content: \"\\e907\";\n}\n.rsk-qid:before {\n  content: \"\\e908\";\n}\n.rsk-risk-map:before {\n  content: \"\\e909\";\n}\n.rsk-sil:before {\n  content: \"\\e90a\";\n}\n.rsk-triangle-right:before {\n  content: \"\\e900\";\n}\n.rsk-decrease-to:before {\n  content: \"\\e91f\";\n}\n.rsk-increase-to:before {\n  content: \"\\e920\";\n}\n.rsk-clock-thin:before {\n  content: \"\\e91e\";\n}\n.rsk-book:before {\n  content: \"\\e91d\";\n}\n.rsk-user:before {\n  content: \"\\e971\";\n}\n.rsk-eye:before {\n  content: \"\\e9ce\";\n}\n.rsk-eye-blocked:before {\n  content: \"\\e9d1\";\n}\n.rsk-radio-checked:before {\n  content: \"\\ea54\";\n}\n.rsk-radio-checked2:before {\n  content: \"\\ea55\";\n}\n.rsk-radio-unchecked:before {\n  content: \"\\ea56\";\n}\n.rsk-cart:before {\n  content: \"\\e93a\";\n}\n.rsk-clock:before {\n  content: \"\\e94e\";\n}\n.rsk-notification:before {\n  content: \"\\ea08\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
